import axios from 'axios'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { auth, db, FirebaseTimestamp } from 'firebase/index'
import { PUSH_NOTIFICATION_ENDPOINT } from 'constants/urls'
import { fetchStocksAction } from 'reducks/stock/actions'
import { StockType } from 'types/stock'

const notifyStocks = (stocks: StockType[]) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const batch = db.batch()
    const currentStocks = getState().stock.stocks
    const storeRef = getState().auth.store_ref

    // トークンを再取得する
    const token = await auth.currentUser?.getIdToken()

    if (typeof !token === 'undefined') {
      console.error('認証トークンの取得に失敗しました。')
      return
    }

    const now = FirebaseTimestamp.now()
    const stockIds: string[] = []

    for (let i = 0; i < stocks.length; i = (i + 1) | 0) {
      const stock = stocks[i]
      if (!stock.stock_ref) continue
      batch.update(stock.stock_ref, { last_notified_time: now })
      stockIds.push(stock.stock_ref.id)
      // Redux Store上のstocksを更新する
      const index = currentStocks.findIndex((currentStock) => currentStock.stock_ref?.path === stock.stock_ref?.path)
      // 前営業日より前に削除扱いとした在庫データと同じ受渡解禁時刻の場合、ローカルの値を更新できない
      if (index === -1) continue
      currentStocks[index].last_notified_time = now
    }

    await axios
      .post(
        PUSH_NOTIFICATION_ENDPOINT,
        {
          store_id: storeRef.id,
          stock_ids: stockIds,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .catch((error) => {
        console.error(error)
      })

    return batch
      .commit()
      .then(() => {
        dispatch(fetchStocksAction(currentStocks))
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export default notifyStocks
